export const getAvatarColor = () => {
  const colors = ['#EC8145', '#CC2F2F', '#6D67AC', '#77A9D7', '#819F77'];
  const randomIndex = Math.floor(Math.random() * 5);
  return colors[randomIndex];
};
